import React from "react";

import { useEffect, useState } from "react";
import Sidebar from "../../../components/Sidebar";
import Topbar from "../../../components/Topbar";
import ChooseCreationTypeSec from "../../../components/jdCreation/ChooseCreationTypeSec";
import { getModuleAccessInfoApi } from "../../../api/candidate";
import Utils from "../../../utils/Utils";
import WebUtils from "../../../utils/WebUtils";
import Loader from "../../../components/Loader";
import NoCreditModal from "../../../components/candidate/preparation/NoCreditModal";
import JdCreationPreview from "../../../components/jdCreation/JdCreationPreview";
import MockBlueprintConfig from "./MockBlueprintConfig";

const userDetail = Utils.getUserDetail();
let userRole = userDetail?.userRole;

function MockCreateNew() {
  const [steps, setSteps] = useState(1);
  const [loading, setLoading] = useState(false);
  const [creditModalFlag, setCreditModalFlag] = useState(false);
  const [jdId, setJdId] = useState(null);
  const [manualGuideFlag, setmanualGuideFlag] = useState(false);
  const [allJobs, setAllJobs] = useState(null);

  const getModuleInfo = async () => {
    const url = `${getModuleAccessInfoApi}?userIdentifier=${
      userDetail?.userIdentifier || null
    }`;

    setLoading(true);

    WebUtils.httpOperations(url, {}, "GET")
      .then((result) => {
        setLoading(false);
        if (
          result.data.resultStatusInfo.resultCode.toLowerCase() === "success"
        ) {
          if (result.data.data.mockInterviewCredits > 0) {
            setCreditModalFlag(false);
          } else {
            setCreditModalFlag(true);
          }
          // setModuleInfo((prev) => ({ ...prev, credits: 0 }));
        }
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      });
  };

  useEffect(() => {
    getModuleInfo();
  }, []);
  return (
    <>
      {loading && <Loader />}
      {creditModalFlag ? (
        <NoCreditModal
          creditModalFlag={creditModalFlag}
          setCreditModalFlag={setCreditModalFlag}
          noClosable={true}
        />
      ) : (
        <div className="hirePlusPlusPageContent">
          <Sidebar activePage="mock-interview" userRole="candidate" />
          <div className="w-full hireplusplusRightContent">
            <Topbar
              activePage="mock-interview"
              userRole="candidate"
              newTitle="Create New Mock Interview"
              driverFlag="create-new-draft"
            />
            <div className="flex flex-col py-2 items-center gap-y-4 justify-center w-full min-h-[80vh] px-3">
              <div className=" text-center py-2">
                {/* <StepsProgress
                steps={["Select Job Role", "Create Guide"]}
                currentStep={steps}
                maxWidth="600px"
              /> */}
                {steps === 1 && !manualGuideFlag && (
                  <span className="text-[#0F1B23] font-semibold text-2xl">
                    Step 1 of 2 : Select Your Job Role
                  </span>
                )}
                {steps === 1 && manualGuideFlag && (
                  <span className="text-[#0F1B23] font-semibold text-2xl">
                    Step 1 of 2: Create Your Job Role
                  </span>
                )}
                {steps === 2 && (
                  <span className="text-[#0F1B23] font-semibold text-2xl">
                    Step 2 of 2: Configure iDrona Interview
                  </span>
                )}
              </div>
              <div className="w-full">
                {steps === 1 && (
                  <ChooseCreationTypeSec
                    setSteps={setSteps}
                    setLoading={setLoading}
                    userDetail={userDetail}
                    setJdId={setJdId}
                    steps={steps}
                    setmanualGuideFlag={setmanualGuideFlag}
                    manualGuideFlag={manualGuideFlag}
                    allJobs={allJobs}
                    setAllJobs={setAllJobs}
                  />
                )}
                {steps === 2 && (
                  <MockBlueprintConfig
                    userDetail={userDetail}
                    jdId={jdId}
                    setLoading={setLoading}
                    setSteps={setSteps}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default MockCreateNew;
